export default __webpack_public_path__ + "static/media/arrowup.bcab2d8e.svg";